export default window.fetch || fetch